import script from "./change-password.vue?vue&type=script&lang=tsx&setup=true"
export * from "./change-password.vue?vue&type=script&lang=tsx&setup=true"

import "./change-password.vue?vue&type=style&index=0&id=bd7c9660&lang=scss"

const __exports__ = script;

export default __exports__